import { configureStore } from '@reduxjs/toolkit';
import { formReducer, referralPageReducer, referralUserReducer } from 'shared/slices';

import type { IApplicationContext } from 'shared/types/applicationContext';
import { IPreloadedState } from '../../types/referral/store';

/**
 * Хелпер для создания Redux стора
 * @param context IApplicationContext - контекст приложения
 * @param preloadedState IPreloadedState - предзагруженное состояние
 * @param debugEnabled boolean - флаг доступности Redux Devtools на деве
 */
export function createReferralReduxStore(
  context: IApplicationContext,
  preloadedState: IPreloadedState,
  debugEnabled: boolean,
) {
  const projectName = context.config.getStrict<string>('projectName');

  return configureStore({
    devTools: debugEnabled ? { name: projectName } : false,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        thunk: {
          extraArgument: context,
        },
      }),
    preloadedState,
    reducer: {
      page: referralPageReducer,
      user: referralUserReducer,
      form: formReducer,
    },
  });
}
